import script from "./TextDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TextDialog.vue?vue&type=script&setup=true&lang=js"

import "./TextDialog.vue?vue&type=style&index=0&id=b43d867c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b43d867c"]])

export default __exports__